import { FormHelperText, styled } from '@mui/material';

const ErrorMessage = styled(FormHelperText)(({ theme }) => ({
  fontSize: '14px',
  letterSpacing: '0.045em',
  color: theme.palette.white.light,
}));

export default ErrorMessage;
